<template>
  <div>
    <vs-table :data="payments">

      <template slot="thead">
        <vs-th :class="{'float-right': title === $t('payments.table.actions')}" :key="i" class="text-base"
               v-for="(title, i) in header">{{ title }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indexTr" v-for="(tr, indexTr) in data">
          <vs-td :data="tr.amount" v-if="showProjectInfo">
            {{ tr.project.client.name }} - {{ tr.project.name }}
          </vs-td>
          <vs-td :data="tr.amount">
            {{ tr.amount }}{{ tr.currency | currency}}
          </vs-td>
          <vs-td :data="tr.status">
            {{ tr.status }}
          </vs-td>
          <vs-td :data="tr.sent_at" class="whitespace-pre">
            {{ tr.sent_at | fromShortDate }}
          </vs-td>
          <vs-td :data="tr.paid_at" class="whitespace-pre">
            <span>{{ tr.paid_at | fromShortDate }}</span>
          </vs-td>
          <vs-td class="text-right">
            <div class="flex justify-end">
              <vx-tooltip :text="$t('payments.paymentReceived')" position="top">
                <base-button :disabled="tr.status === 'PAID'" @click="confirmPayment(tr.id)" class="self-end px-3 mx-px"
                             icon="check"/>
              </vx-tooltip>
              <vx-tooltip :text="$t('buttons.delete')" position="top">
                <base-button :disabled="!tr.is_deletable" @click="deletePayment(tr.id)" class="self-end px-3 mx-px"
                             color="danger"
                             icon="trash"/>
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import Payments from '../../services/Payments';

  export default {
    name: 'PaymentsTable',
    components: {},
    props: {
      header: {
        type: Array,
        required: true
      },
      payments: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      showProjectInfo: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      deletePayment (id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('payments.deleteTitle'),
          text: this.$t('payments.deleteText'),
          accept: () => {
            Payments.delete(id).then(() => {
              this.$emit('refresh');
            }, (error) => {
              this.$notificationService.error(error.message);
            });
          }
        });
      },
      confirmPayment (id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('payments.confirmTitle'),
          text: this.$t('payments.confirmText'),
          accept: () => {
            Payments.confirm(id).then(() => {
              this.$emit('refresh');
            }, (error) => {
              this.$notificationService.error(error.message);
            });
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
